<script setup lang="ts">
import { ref } from 'vue';
import type { Language } from '@ilteducation/content-ref-data-types';

const props = withDefaults(
  defineProps<{
    languageOptions: Language[];
  }>(),
  {},
);

const emit = defineEmits<{ setup: [lang: string] }>();

const selectedLanguage = ref<string>('11');
</script>

<template>
  <div class="init-config-container">
    <v-card-title>
      <v-spacer />
      <h2>Titel - film/kategori osv...</h2>
      <v-spacer />
    </v-card-title>
    <div class="game-placeholder">
      <p class="game-placeholder-text">Starta... 3-2-1....</p>
      <v-btn @click="emit('setup', selectedLanguage)">GO!</v-btn>
    </div>

    <v-card-text>
      <h3>Match explanations and... (instruction)</h3>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-select
        v-model="selectedLanguage"
        :items="props.languageOptions"
        :item-text="(item: Language) => item.language"
        variant="solo"
        class="language-selector"
      ></v-select>
      <v-spacer />
    </v-card-actions>
  </div>
</template>

<style lang="scss">
.game-placeholder {
  background-color: #d9d9d9;
  display: inline-block;
  text-align: center;
  width: 657.82px;
  height: 423.6px;
  border: 1px solid #d9d9d9;
  margin-bottom: 48px;
}
.game-placeholder-text {
  text-align: center;
  vertical-align: middle;
  line-height: 90px;
}
.language-selector {
  max-width: 213px;
}
</style>
